const cartRootEl = document.getElementById('cartApp');
const itemComponent = {
    data() {
        return {}
    },
    props: {
        item: Object
    },
    inject: ['loading','discount'],
    created() {

    },
    emits: ['remove','update'],
    computed: {
        itemName() {
            return (this.item.hasOwnProperty('properties') && this.item.properties.hasOwnProperty('_name') && this.item.properties['_name']) ? this.item.properties['_name'] : '';
        },
        itemImage() {
            let img = null;
            if(this.item.hasOwnProperty('properties')) {
                if(this.item.properties.hasOwnProperty('_cropped_image') && this.item.properties['_cropped_image']) {
                    img = this.item.product_type.toLowerCase() === 'canvas' ? this.previewUrl + this.item.properties['_cropped_image'] : this.item.properties['_cropped_image'];
                } else if(this.item.properties.hasOwnProperty('_canvas_image') && this.item.properties['_canvas_image']) {
                    img = this.item.properties['_canvas_image'];
                } else if(this.item.properties.hasOwnProperty('_original_image') && this.item.properties['_original_image']) {
                    img = this.item.properties['_original_image'];
                }
            }
            return img;
        },
        itemUrl() {
            let url = null;
            const type = this.item.product_type ? this.item.product_type.toLowerCase() : null;
            if(type === 'fixedprice' || type === 'ShopifyWallpaper' || type === 'ShopifyMural' || type === 'ShopifyCanvas') {
                url = '/products/'+this.item.handle;
            } else {
                if(this.item.hasOwnProperty('properties')) {
                if(this.item.properties.hasOwnProperty('_product_url') && this.item.properties['_product_url'] !== null) {
                    return this.item.properties['_product_url'];
                } else if(this.item.properties.hasOwnProperty('_url_key') && this.item.properties['_url_key'] && this.item.properties['_url_key'] !== 'null') {
                        url = this.item.properties['_url_key']
                    } else if(this.item.properties.hasOwnProperty('_id') && this.item.properties['_id']) {
                        url = this.item.properties['_id']
                    }
                }
                if(url && type) {
                    if(type === 'sample') {
                        url = '/products/mural/' + url;
                    } else {
                        url = '/products/' + type + '/' + url;
                    }
                }
            }

            if(!url) {
                url = '#';
            }
            return url;
        },
        isSample() {
            return this.item.product_type.toLowerCase() === 'sample';
        },
        isFixedPrice() {
            return ['fixedprice'].includes(this.item.product_type.toLowerCase());
        },
        type() {
            return this.item.product_type.toLowerCase();
        },
        size() {
            let s = {
                'width': null,
                'height': null,
            };
            if(this.item && this.item.hasOwnProperty('properties')) {
                if(this.item.properties.hasOwnProperty('Size')) {
                    let sa = this.item.properties['Size'].split('x');
                    s['width'] = sa[0].trim();
                    s['height'] = sa[1].trim();
                } else {
                    if(this.item.properties.hasOwnProperty('Width')) {
                        s['width'] = this.item.properties['Width'];
                    }
                    if(this.item.properties.hasOwnProperty('Height')) {
                        s['height'] = this.item.properties['Height'];
                    }
                }
            }
            return s;
        },
        topcoat() {
            return this.item && this.item.hasOwnProperty('properties') && this.item.properties.hasOwnProperty('Topcoat') ? this.item.properties['Topcoat'] : null;
        },
        options() {
            return this.item && this.item.hasOwnProperty('properties') && this.item.properties.hasOwnProperty('Options') ? this.item.properties['Options'] : null;
        },
        materials() {
            return this.item && this.item.hasOwnProperty('properties') && this.item.properties.hasOwnProperty('Materials') ? this.item.properties['Materials'] : null;
        },
        comments() {
            return this.item && this.item.hasOwnProperty('properties') && this.item.properties.hasOwnProperty('Comments') ? this.item.properties['Comments'] : null;
        },
        width() {
            return this.size['width'];
        },
        height() {
            return this.size['height'];
        },
        quantity() {
            if(this.item.product_type === 'ShopifyWallpaper' || this.item.product_type === 'ShopifyMural' || this.item.product_type === 'ShopifyCanvas') return parseInt(this.item.quantity);
            return this.item && this.item.hasOwnProperty('properties') && this.item.properties.hasOwnProperty('_quantity') ? parseInt(this.item.properties['_quantity']) : 1;
        },
        croppedImage() {
            return this.item && this.item.hasOwnProperty('properties') &&
            this.item.properties.hasOwnProperty('_cropped_image') &&
            this.item.properties['_cropped_image'] !== '' ? this.item.properties['_cropped_image'] : null;
        },
    },
    methods: {
        onQtyButtonClick() {
            let qty = this.quantity;
            event.target.classList.contains('inc-qty') ? qty++ : qty--;
            if(qty < 1) {
                qty = 0;
            }
            if(qty !== this.quantity) {
                if(qty > 0) {
                    this.$emit('update', this.item, qty);
                } else {
                    this.$emit('remove', this.item);
                }
            }
        },
        updateProductQty() {
            let qty = parseInt(event.target.value);
            if(qty < 1) {
                qty = 0;
            }
            if(qty !== this.quantity) {
                if(qty > 0) {
                    this.$emit('update', this.item, qty);
                } else {
                    this.$emit('remove', this.item);
                }
            }
        },
        quickview() {
            const isMirror = (!this.croppedImage && this.item.properties && this.item.properties['_flip'] && (this.item.properties['_flip'] !== false && this.item.properties['_flip'] !== 'false')) ? ' mirror' : '';
            const isDesaturate = (this.item.properties && this.item.properties['_bw'] && (this.item.properties['_bw'] !== false && this.item.properties['_bw'] !== 'false')) ? ' desaturate' : '';
            const modalBody = `<div id="modalImage" class="image${isMirror}${isDesaturate}"><img src="${this.itemImage}" alt=""></div>`;
            store.dispatch('modal/set', {
                'modalBody': modalBody
            });
            store.dispatch('modal/open');
        }
    },
    template: `<div class="row cart-table-row" :class="{'loading': loading === item.key}">
              <div class="col-md-4 col-6">
                <a :href="itemUrl"><span class="product-image" :class="{'mirror': !croppedImage && item.properties && item.properties['_flip'] && item.properties['_flip'] === 'true','desaturate': item.properties && item.properties['_bw'] && item.properties['_bw'] === 'true' }"><img :src="itemImage" alt=""></span></a>
                <div class="action-set visible-xs-block"><a href="#" class="view-larger" @click.prevent="quickview"><i class="fa fa-search" aria-hidden="true"></i> View Larger</a></div>
              </div>
              <div class="col-md-8 col-6 product-details-wrapper">
                <div class="row">
                  <div class="col-md-7">
                    <div class="product-details">
                      <h2 class="product-name"><a :href="itemUrl" v-html="itemName"></a></h2>
                      <div class="item-options" v-if="item.type !== 'FixedPrice'">
                        <template v-if="type !== 'sample'">
                        <p class="item-option size-options"><span><strong>Width:</strong>&nbsp;{{width}}&nbsp;&nbsp;&nbsp;</span><span><strong>Height:</strong>&nbsp;{{height}}</span></p>
                        </template>
                        <template v-if="type === 'canvas' && comments">
                          <p class="item-option" v-html="comments"></p>
                        </template>
                        <template v-if="type !== 'canvas'">
                          <p class="item-option" v-if="materials"><strong>Materials:</strong>&nbsp;{{materials}}</p>
                          <p class="item-option" v-if="options"><strong>Options:</strong>&nbsp;{{options}}</p>
                          <p class="item-option" v-if="topcoat"><strong>Topcoat:</strong>&nbsp;{{topcoat}}</p>
                          <p class="item-option" v-if="comments"><strong>Comments:</strong>&nbsp;{{comments}}</p>
                        </template>
                      </div>
                      <div class="item-options" v-if="type !== 'sample' && type !== 'fixedprice'"><a :href="itemUrl" title="Edit item parameters">Edit</a></div>
                      <div class="qty-wrapper hidden-xs">
                        <button class="dec-qty" @click.prevent="onQtyButtonClick" :disabled="isSample || isFixedPrice">-</button><input title="Qty" class="input-text qty" :value="quantity" @change="updateProductQty" :readonly="isSample || isFixedPrice"><button class="inc-qty" @click.prevent="onQtyButtonClick" :disabled="isSample || isFixedPrice">+</button>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 product-price-container hidden-xs">
                    <div class="product-price" v-if="item.discount_percent > 0 && item.original_line_price && item.original_line_price > item.line_price">
                      <p class="old-price"><span class="price">{{formatCurrency(item.original_line_price)}}</span></p>
                      <p class="special-price"><span class="price">{{formatCurrency(item.line_price)}}</span></p>
                      <span class="price-disclaimer">with your {{item.discount_percent}}% discount</span>
                    </div>
                    <div class="product-price" v-else>
                      <p><span class="price">{{formatCurrency(item.original_line_price)}}</span></p>                    
                    </div>
                  </div>
                </div>
                <div class="row action-set hidden-xs product-image" :class="{'is-mirror': !croppedImage && item.properties && item.properties['_flip'] && item.properties['_flip'] === 'true','is-desaturate': item.properties && item.properties['_bw'] && item.properties['_bw'] === 'true' }">
                  <div class="col-6"><a href="#" class="view-larger" @click.prevent="quickview"><i class="fa fa-search" aria-hidden="true"></i> View Larger</a></div>
                  <div class="col-6"><a href="#" class="btn-remove btn-remove3" @click.prevent="$emit('remove',item)"><i class="fa fa-trash" aria-hidden="true"></i> Remove</a></div>
                </div>
              </div>
              <div class="col-12 mobile-container">
                <div class="qty-wrapper">
                  <button class="dec-qty" @click.prevent="onQtyButtonClick" :disabled="isSample || isFixedPrice">-</button><input title="Qty" class="input-text qty" :value="quantity" @change="updateProductQty" :readonly="isSample || isFixedPrice"><button class="inc-qty" @click.prevent="onQtyButtonClick" :disabled="isSample || isFixedPrice">+</button>
                </div>
                <div class="product-price" v-if="item.discount_percent > 0 && item.original_line_price && item.original_line_price > item.line_price">
                  <p class="old-price"><span class="price">{{formatCurrency(item.original_line_price)}}</span></p>
                  <p class="special-price"><span class="price">{{formatCurrency(item.line_price)}}</span></p>
                  <span class="price-disclaimer">with your {{item.discount_percent}}% discount</span>
                </div>
                <div class="product-price" v-else>
                  <p><span class="price">{{formatCurrency(item.original_line_price)}}</span></p>                    
                </div>
              </div>
              <a href="#" class="btn-remove btn-remove3 visible-xs-block" @click.prevent="$emit('remove',item)"><i class="fa fa-trash" aria-hidden="true"></i><span class="sr-only">Remove</span></a>
            </div>`
}
const cartApp = Vue.createApp({
    components: {
        'item': itemComponent
    },
    data() {
        return {
            discount: null,
            fetchHeaders: new Headers({'pragma':'no-cache','cache-control':'no-store','Content-Type':'application/json'}),
            cartAddUrl: '/cart/add.js',
            cartUpdateUrl: '/cart/update.js',
            cartChangeUrl: '/cart/change.js',
            cartUrl: '/cart.js',
            cartLoaded: false,
            isLoading: null,
            items: [],
            cartContainer: null,
            cart: {},
            couponError: false
        }
    },
    props: ['imageOne','imageTwo','imageThree'],
    template: `
    <teleport to="#page-title"><h1>{{ cartTitle }}</h1></teleport>
    <template v-if="cartLoaded">
      <template v-if="items.length === 0">
        <teleport to="#cartEmpty">
        <div class="cart-empty">
            <p>You have no items in your shopping cart.</p>
            <p><a href="/collections/murals" class="magento-btn">Shop Murals</a> <a href="/collections/canvas" class="magento-btn">Shop Canvas</a></p>
            <br>
            <br>
            <div class="home-applications home-applications-footer">
                <div class="app-wrap">
                    <ul>
                        <li class="shop-list">
                            <div class="shop-cat-wrap">
                                <div class="coll-shop-img"><img alt="wall-mural-installation-tips" :src="imageOne"></div>
                                <div class="coll-shop-name">
                                    <h1>Easy Install Tips</h1></div>
                                <div class="coll-shop-hover"><a href="/pages/installation">view</a></div>
                            </div>
                        </li>
                        <li class="shop-list">
                            <div class="shop-cat-wrap">
                                <div class="coll-shop-img"><img alt="wall-mural-decals-ideas" :src="imageTwo"></div>
                                <div class="coll-shop-name">
                                    <h1>Need Ideas</h1></div>
                                <div class="coll-shop-hover"><a href="/blogs/blog">view</a></div>
                            </div>
                        </li>
                        <li class="shop-list">
                            <div class="shop-cat-wrap">
                                <div class="coll-shop-img"><img alt="shooting-photo-guide-wall-murals" :src="imageThree"></div>
                                <div class="coll-shop-name">
                                    <h1>Shooting Photos For Large Wall Murals</h1></div>
                                <div class="coll-shop-hover"><a href="/blogs/blog/shooting-photos-for-large-wall-murals">view</a></div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        </teleport>
      </template>
      <template v-else>
        <teleport to="#cartSummary" v-if="isPartner">
        <div class="cart-totals" :class="{'loading':isLoading === 'coupon'}">
          <p><span class="label">Subtotal</span><span class="total">{{formatCurrency(cart.original_total_price)}}</span></p>
          <p v-if="cart.total_discount > 0"><span class="label">Discount Code</span><span class="total negative">-{{formatCurrency(cart.total_discount)}}</span></p>
          <form id="discount-coupon-form" method="post" @submit.prevent="applyCoupon" v-if="false">
            <div class="discount-form">
                <label class="sr-only" for="coupon_code">Enter your coupon code if you have one.</label>
                <div class="input-box">
                    <input class="input-text required-entry" id="coupon_code" @focus="couponError=false" name="coupon_code" value="" placeholder="Enter coupon code" :class="{'validation-failed':couponError}" />
                    <div class="validation-advice" v-if="couponError">This is a required field.</div>
                    <button type="submit" class="button">Apply</button>
                </div>
            </div>
          </form>
          <template v-if="discounts.length > 0">
            <p>Applied discount codes:</p>
            <p class="applied-coupons">
              <span v-for="discount in discounts"><span>{{discount.title}}</span><a class="remove-coupon" href="#" v-if="discount.type !== 'automatic'"><i class="fa fa-times-circle" aria-hidden="true"></i></a></span>
            </p>
          </template>
          <p class="grand-total"><span class="label">Total</span><span class="total">{{formatCurrency(cart.total_price)}}</span></p>
        </div>
        </teleport>
        <teleport to="#cartTotals"><span class="totals__subtotal-value">{{formatCurrency(cart.total_price)}}</span></teleport>
        <div class="cart-table-container">
          <template v-for="(item, index) in items" :key="item.key">
            <item :item="item" @update="update" @remove="remove"></item>          
          </template>
        </div>
      </template>
    </template>`,
    created() {
        this.updateCart();
        document.body.addEventListener('docapp-discount-applied', (e) => this.updateDiscounts(e));
        document.body.addEventListener('docapp-widgets-updated', (e) => this.updateDiscounts(e));
    },
    mounted() {
        this.cartContainer = document.querySelector('.cart');
    },
    watch: {
        items(newItems, oldItems) {
            if(this.cartLoaded) {
                if(newItems.length > 0) {
                    this.cartContainer.classList.remove('cart-empty');
                } else {
                    this.cartContainer.classList.add('cart-empty');
                }
            }
        },
    },
    provide() {
        return {
            loading: Vue.computed(() => this.isLoading),
            discount: Vue.computed(() => this.discount)
        }
    },
    computed: {
        cartTitle() {
            if(this.cartLoaded) {
                if(this.items.length > 0) {
                    return 'Cart'
                } else {
                    return 'Shopping Cart is Empty'
                }
            }
        },
        discounts() {
            const discounts = [];
            if(window.customerIsPartner && window.partnerDiscount > 0 && window.partnerDiscountCode !== '') {
                discounts.push({
                    'title': window.partnerDiscountCode,
                    'type': 'automatic'
                })
            }
            return discounts;
        },
        isPartner() {
            return window.customerIsPartner;
        },
        totalDiscount() {
            let discount = 0;
            if(this.cartLoaded && window.customerIsPartner && window.partnerDiscount > 0 && window.partnerDiscountCode !== '') {

            }
        }
    },
    methods: {
        remove(item) {
            this.update(item,0);
        },
        update(item,qty) {
            let lineNo = this.items.findIndex(i => i.handle === item.handle);
            let cartQty = qty;
            let data = {
                'line': (lineNo + 1),
                'quantity': cartQty
            }
            if(qty > 0) {
                data['properties'] = item.properties;
                data['properties']['_quantity'] = qty;
            }
            const body = JSON.stringify(data);
            this.isLoading = item.key;
            fetch(this.cartChangeUrl,{method: 'POST', headers: this.fetchHeaders , body})
                .then((response) => response.json())
                .then((parsedState) => {
                    if(parsedState.status && parsedState.message) {
                        throw new Error(parsedState.message);
                    }
                    if(parsedState) {
                        this.cart = parsedState;
                        if(parsedState.items) {
                            this.items = parsedState.items;
                        }
                    }
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    this.isLoading = '';
                });
        },
        applyCoupon() {
            const coupon = document.getElementById('coupon_code').value;
            if(!coupon) {
                this.couponError = true;
                return false;
            }
            const query = new URLSearchParams({
                discount: coupon
            });
            this.isLoading = 'coupon';
            fetch("/checkout?".concat(query))
              .then((response) => response.text())
              .then((html) => {
                  const newDoc = new DOMParser().parseFromString(html, 'text/html');
                var $ = newDoc.querySelector.bind(newDoc);
                var discountType = $('.total-line.total-line--reduction');
                discountType = discountType && discountType.dataset && discountType.dataset.discountType;
                var CDAT = $('tr.total-line--reduction td.total-line__price .order-summary__emphasis');
                CDAT = CDAT && CDAT.dataset && CDAT.dataset.checkoutDiscountAmountTarget;
                var CPDT = $('.payment-due__price');
                CPDT = CPDT && CPDT.dataset && CPDT.dataset.checkoutPaymentDueTarget;
                var totalText = $('.payment-due-label__total');
                totalText = totalText && totalText.innerText || 'Total';
                var discountText = $('.total-line__name span');
                discountText = discountText && discountText.innerText || 'Discount';

                var error = $('#error-for-reduction_code');
                if (error != null) {
                  return {
                    discountType: 'error',
                    checkoutDiscountAmountTarget: 0,
                    checkoutPaymentDueTarget: 0,
                    discountText: error.innerText,
                    totalText: 'error'
                  };
                }
                return {
                  discountType: discountType,
                  checkoutDiscountAmountTarget: CDAT,
                  checkoutPaymentDueTarget: CPDT,
                  discountText: discountText,
                  totalText: totalText
                };
              }).then((response) => {
                console.log('updateDiscountData',response);
                if(response && response.hasOwnProperty('discountType')) {
                  if(response.discountType === 'error') {
                    const errorText = response.hasOwnProperty('discountText') ? response.discountText : `Coupon code "${coupon}" is not valid.`;
                    this.showError(errorText);
                  } else if(response.discountType === 'percentage' || response.discountType === 'fixed_amount') {
                    response.discountCode = coupon;
                    this.updateCart();
                  } else {
                      this.showError(`Coupon code "${coupon}" is not valid.`);
                  }
                } else {
                    this.showError(`Coupon code "${coupon}" is not valid.`);
                }
              }).catch(() => {
                this.showError(`Coupon code "${coupon}" is not valid.`);
              }).finally(() => {
                this.isLoading = null;
              });
        },
        showError(e) {
            store.dispatch('messages/set', {
                'message': e,
                'type': 'error'
            })
        },
        updateDiscounts(e) {
            if(window.customerIsPartner) {
                return false;
            }
            if(e && e.hasOwnProperty('cart') && e.cart && e.cart.hasOwnProperty('items') && e.cart.items && e.cart.items.length) {
                console.log(e);
                e.cart.items.forEach((item) => {
                    this.items.forEach((cartItem) => {
                        if(cartItem.variant_id === item.variant_id) {
                            if(item.original_line_price && item.original_line_price > item.line_price) {
                                cartItem['discount_percent'] = Math.round((1 - (item.line_price / item.original_line_price)) * 100);
                            } else {
                                cartItem['discount_percent'] = 0;
                            }
                            cartItem['line_price'] = item.line_price;
                        }
                    });
                })
            }
        },
        updateCart() {
            const ms = Date.now();
            let url = this.cartUrl + '?_=' + ms;
            this.isLoading = 'cart';
            fetch(url,{method: 'GET', headers: this.fetchHeaders})
                .then((response) => response.json())
                .then((parsedState) => {
                    if(parsedState.status && parsedState.message) {
                        throw new Error(parsedState.message);
                    }
                    if(parsedState) {
                        this.cart = parsedState;
                        if(parsedState.items) {
                            parsedState.items.forEach((item) => {
                                item['discount_percent'] = 0;
                            });
                            this.items = parsedState.items;
                        }
                    }
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    this.cartLoaded = true;
                    this.isLoading = null;
                });
        },
    }
}, { ...cartRootEl.dataset })
cartApp.use(AdobeClientPlugin).use(store);
cartApp.config.compilerOptions.isCustomElement = tag => tag.includes('-') && !tag.includes('router') && !tag.includes('api')
cartApp.config.unwrapInjectedRef = true
document.addEventListener('DOMContentLoaded', function () {
    cartApp.mount('#cartApp');
});

function checkImg(el){
    var m = document.getElementById('modalImage');
    if(el.classList.contains('is-mirror')){
        m.classList.add('mirror');
    }else{
        m.classList.remove('mirror');
    }

    if(el.classList.contains('is-desaturate')){
        m.classList.add('desaturate');
    }else{
        m.classList.remove('desaturate');
    }
}

function clearDiscount() {
    discountCodeValue.innerHTML = "";
    discountCodeError.innerHTML = "";
    clearLocalStorage();
    fetch("/discount/CLEAR");
    refreshDiscount();
}

function clearLocalStorage() {
    if(discountCodeWrapper) discountCodeWrapper.style.display = "none";
    if(totalCartSelector) totalCartSelector.innerHTML = JSON.parse(localStorage.discountCode).totalCart;
    localStorage.removeItem("discountCode");
}

function refreshDiscount() {
    try { 
        fetch( '/discount/DISCOUNTCODE' )
    }
    catch(e) {}
}
